import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import apiResponses from './personalAreaLayout.json';

const getLoginStatus = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['authorizationController/getLoginStatus'].success.default)));
};
const getMetaDataTagByPath = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['metaTagController/getMetaDataTagByPath'].success.default)));
};
const check = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['login/check'].success.default)));
};
const checkPageAuthorization = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['authorizationController/checkPageAuthorization'].success.default)));
};
const queryProductType = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['personalAreaController/queryProductType'].success.default)));
};
const queryPaymentInfo = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['paymentController/queryPaymentInfo'].success.default)));
};
const getMemberLevel = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['FcoinController/getMemberLevel'].success.default)));
};
const queryContractsInfo = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['contractController/queryContractsInfo'].success.default)));
};
const queryRateInfo = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['rateController/queryRateInfo'].success.default)));
};
const getFunctionData = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['functionDataController/getFunctionData'].success.default)));
};
const getInstantServiceUsage = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['personalAreaController/queryInstantServiceUsage'].success.default)));
};


export const handlers = [
  rest.post(getApiEndpoint('authorizationController/getLoginStatus'), withScenario(withAuthCheck(getLoginStatus))),
  rest.post(getApiEndpoint('metaTagController/getMetaDataTagByPath'), withScenario(withAuthCheck(getMetaDataTagByPath))),
  rest.post(getApiEndpoint('login/check'), withScenario(withAuthCheck(check))),
  rest.post(getApiEndpoint('authorizationController/checkPageAuthorization'), withScenario(withAuthCheck(checkPageAuthorization))),
  rest.post(getApiEndpoint('personalAreaController/queryProductType'), withScenario(withAuthCheck(queryProductType))),
  rest.post(getApiEndpoint('paymentController/queryPaymentInfo'), withScenario(withAuthCheck(queryPaymentInfo))),
  rest.post(getApiEndpoint('FcoinController/getMemberLevel'), withScenario(withAuthCheck(getMemberLevel))),
  rest.post(getApiEndpoint('contractController/queryContractsInfo'), withScenario(withAuthCheck(queryContractsInfo))),
  rest.post(getApiEndpoint('rateController/queryRateInfo'), withScenario(withAuthCheck(queryRateInfo))),
  rest.post(getApiEndpoint('functionDataController/getFunctionData'), withScenario(withAuthCheck(getFunctionData))),
  rest.post(getApiEndpoint('personalAreaController/queryInstantServiceUsage'), withScenario(withAuthCheck(getInstantServiceUsage))),
];